module.exports = __webpack_public_path__ + "static/media/ETANG_EQ_INTERIEUR_RED.b93b8a25.webp";